// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#SaleDetailProduct_component img {
  width: 100px;
}

.modifiedDesign {
  color: red;
}

.container-fluid {
  font-size: 13px;
}
.container-fluid .link_to_sales {
  margin-top: 10px;
  margin-bottom: 20px;
}
.container-fluid .sale_detail h2 {
  text-align: center;
  padding: 6px 2px;
}
.container-fluid .sale_detail .details {
  padding: 6px 6px;
}
.container-fluid .sale_detail .details table {
  width: 100%;
}
.container-fluid .sale_detail .details table tr td {
  width: 50%;
}
.container-fluid table tr td {
  vertical-align: top;
  padding: 2px 6px;
}

.container-fluid .sale_detail .customers_information {
  border: 1px solid #FF9AA2;
}
.container-fluid .sale_detail .customers_information h2 {
  background-color: #FF9AA2;
}

.container-fluid .sale_detail .payment_information {
  margin-top: 20px;
  border: 1px solid #FFB7B2;
}
.container-fluid .sale_detail .payment_information h2 {
  background-color: #FFB7B2;
}

.container-fluid .sale_detail .products_information {
  border: 1px solid #FFDAC1;
}
.container-fluid .sale_detail .products_information h2 {
  background-color: #FFDAC1;
}
.container-fluid .sale_detail .products_information .products .add_express_manufacturing {
  color: red;
  font-size: 13px;
  text-align: center;
}

.container-fluid .sale_detail .history {
  margin-top: 20px;
  border: 1px solid #E2F0CB;
}
.container-fluid .sale_detail .history h2 {
  background-color: #E2F0CB;
}

.container-fluid .sale_detail .manufacturing_information {
  margin-top: 20px;
  border: 1px solid #B5EAD7;
}
.container-fluid .sale_detail .manufacturing_information h2 {
  background-color: #B5EAD7;
}
.container-fluid .sale_detail .manufacturing_information .button_link {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}

.container-fluid .sale_detail .discussion {
  border: 1px solid #C7CEEA;
}
.container-fluid .sale_detail .discussion h2 {
  background-color: #C7CEEA;
}

#SaleDetail_component {
  height: 100vh;
  overflow: auto;
}
#SaleDetail_component .detail_components .order-number {
  background-color: #71CFD1;
  color: white;
  padding: 20px 25px;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  margin-bottom: 20px;
  margin-top: 20px;
  text-align: center;
}
#SaleDetail_component .detail_components .sale_data {
  background-color: white;
  border: 1px solid #d2d2d2;
  border-radius: 20px;
  background: #FFFFFF;
  box-shadow: 0px 15px 33px rgba(0, 0, 0, 0.08);
  margin-bottom: 30px;
}
#SaleDetail_component .detail_components .sale_data .heading {
  background-color: #8BA6EB;
  color: white;
  padding: 20px 25px;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
}
#SaleDetail_component .detail_components .sale_data .row {
  border-bottom: 1px solid #d2d2d2;
}
#SaleDetail_component .detail_components .sale_data .row:last-child {
  border: none;
}
#SaleDetail_component .detail_components .sale_data .sales_media_desc {
  max-height: 200px;
  overflow: auto;
  font-size: 10px;
}
#SaleDetail_component .detail_components .sale_data .sales_media_img {
  width: 70px;
  height: 70px;
  border: 1px solid #eee;
}

#SaleDetailSalesLog_component .activity-old-value {
  color: #FF6B00;
}
#SaleDetailSalesLog_component .activity-new-value {
  color: #FF9800;
}`, "",{"version":3,"sources":["webpack://./src/css/sales/sale_detail.scss"],"names":[],"mappings":"AAQI;EACI,YAAA;AAPR;;AAWA;EACI,UAAA;AARJ;;AAWA;EACI,eAZgB;AAIpB;AASI;EACI,gBAAA;EACA,mBAAA;AAPR;AAUQ;EACI,kBAAA;EACA,gBAAA;AARZ;AAUQ;EACI,gBAAA;AARZ;AASY;EACI,WAAA;AAPhB;AAQgB;EACI,UAAA;AANpB;AAYQ;EACI,mBAAA;EACA,gBAAA;AAVZ;;AAiBQ;EAII,yBAAA;AAjBZ;AAcY;EACI,yBAlDF;AAsCd;;AAqBQ;EACI,gBAAA;EAIA,yBAAA;AArBZ;AAkBY;EACI,yBA7DF;AA6Cd;;AAyBQ;EAII,yBAAA;AAzBZ;AAsBY;EACI,yBAvED;AAmDf;AAwBgB;EACI,UAAA;EACA,eAAA;EACA,kBAAA;AAtBpB;;AA+BQ;EACI,gBAAA;EAIA,yBAAA;AA/BZ;AA4BY;EACI,yBAzFF;AA+Dd;;AAmCQ;EACI,gBAAA;EAIA,yBAAA;AAnCZ;AAgCY;EACI,yBApGF;AAsEd;AAiCY;EACI,WAAA;EACA,gBAAA;EACA,mBAAA;AA/BhB;;AAuCQ;EAII,yBAAA;AAvCZ;AAoCY;EACI,yBAnHA;AAiFhB;;AAyCA;EACI,aAAA;EACA,cAAA;AAtCJ;AAwCQ;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAtCZ;AAwCQ;EACI,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6CAAA;EACA,mBAAA;AAtCZ;AAuCY;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,4BAAA;AArChB;AAuCY;EACI,gCAAA;AArChB;AAsCgB;EACI,YAAA;AApCpB;AAuCY;EACI,iBAAA;EACA,cAAA;EACA,eAAA;AArChB;AAuCY;EACI,WAAA;EACA,YAAA;EACA,sBAAA;AArChB;;AA4CI;EACI,cAAA;AAzCR;AA2CI;EACI,cAAA;AAzCR","sourcesContent":["$color_red_1: #FF9AA2;\n$color_red_2: #FFB7B2;\n$color_orange: #FFDAC1;\n$color_grass: #E2F0CB;\n$color_green: #B5EAD7;\n$color_purlple: #C7CEEA;\n$font_size_content: 13px;\n#SaleDetailProduct_component {\n    img {\n        width: 100px;\n    }\n}\n\n.modifiedDesign {\n    color: red;\n}\n\n.container-fluid {\n    font-size: $font_size_content;\n    .link_to_sales {\n        margin-top: 10px;\n        margin-bottom: 20px;\n    }\n    .sale_detail {\n        h2 {\n            text-align: center;\n            padding: 6px 2px;\n        }\n        .details {\n            padding: 6px 6px;\n            table {\n                width: 100%;\n                tr td {\n                    width: 50%;\n                }\n            }\n        }\n    }\n    table {\n        tr td {\n            vertical-align: top;\n            padding: 2px 6px;\n        }\n    }\n}\n\n.container-fluid {\n    .sale_detail {\n        .customers_information {\n            h2 {\n                background-color: $color_red_1;\n            }\n            border: 1px solid $color_red_1;\n        }\n    }\n}\n\n.container-fluid {\n    .sale_detail {\n        .payment_information {\n            margin-top: 20px;\n            h2 {\n                background-color: $color_red_2;\n            }\n            border: 1px solid $color_red_2;\n        }\n    }\n}\n\n.container-fluid {\n    .sale_detail {\n        .products_information {\n            h2 {\n                background-color: $color_orange;\n            }\n            border: 1px solid $color_orange;\n            .products {\n                .add_express_manufacturing {\n                    color: red;\n                    font-size: 13px;\n                    text-align: center;\n                }\n            }\n        }\n    }\n}\n\n.container-fluid {\n    .sale_detail {\n        .history {\n            margin-top: 20px;\n            h2 {\n                background-color: $color_grass;\n            }\n            border: 1px solid $color_grass;\n        }\n    }\n}\n\n.container-fluid {\n    .sale_detail {\n        .manufacturing_information {\n            margin-top: 20px;\n            h2 {\n                background-color: $color_green;\n            }\n            border: 1px solid $color_green;\n            .button_link {\n                width: 100%;\n                margin-top: 20px;\n                margin-bottom: 20px;\n            }\n        }\n    }\n}\n\n.container-fluid {\n    .sale_detail {\n        .discussion {\n            h2 {\n                background-color: $color_purlple;\n            }\n            border: 1px solid $color_purlple;\n        }\n    }\n}\n\n#SaleDetail_component {\n    height: 100vh;\n    overflow: auto;\n    .detail_components {\n        .order-number {\n            background-color: #71CFD1;\n            color: white;\n            padding: 20px 25px;\n            border-top-right-radius: 20px;\n            border-top-left-radius: 20px;\n            margin-bottom: 20px;\n            margin-top: 20px;\n            text-align: center;\n        }\n        .sale_data {\n            background-color: white;\n            border: 1px solid #d2d2d2;\n            border-radius: 20px;\n            background: #FFFFFF;\n            box-shadow: 0px 15px 33px rgba(0, 0, 0, 0.08);\n            margin-bottom: 30px;\n            .heading {\n                background-color: #8BA6EB;\n                color: white;\n                padding: 20px 25px;\n                border-top-right-radius: 20px;\n                border-top-left-radius: 20px;\n            }\n            .row {\n                border-bottom: 1px solid #d2d2d2;\n                &:last-child {\n                    border: none;\n                }\n            }\n            .sales_media_desc {\n                max-height: 200px;\n                overflow: auto;\n                font-size: 10px;\n            }\n            .sales_media_img {\n                width: 70px;\n                height: 70px;\n                border: 1px solid #eee;\n            }\n        }\n    }\n}\n\n#SaleDetailSalesLog_component {\n    .activity-old-value {\n        color: #FF6B00;\n    }\n    .activity-new-value {\n        color: #FF9800;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
